/* tslint:disable */
/* eslint-disable */
/**
 * Bookings API
 * Bookings API
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { UpdateReservationRequestPolicy } from './UpdateReservationRequestPolicy';
import {
    UpdateReservationRequestPolicyFromJSON,
    UpdateReservationRequestPolicyFromJSONTyped,
    UpdateReservationRequestPolicyToJSON,
    UpdateReservationRequestPolicyToJSONTyped,
} from './UpdateReservationRequestPolicy';

/**
 * 
 * @export
 * @interface UpdateReservationRequest
 */
export interface UpdateReservationRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    surname: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    phoneNumber: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    email: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    dateTime: string;
    /**
     * 
     * @type {number}
     * @memberof UpdateReservationRequest
     */
    diners: number;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    customerComments?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    zone: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    zoneId?: string | null;
    /**
     * 
     * @type {UpdateReservationRequestPolicy}
     * @memberof UpdateReservationRequest
     */
    policy: UpdateReservationRequestPolicy;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateReservationRequest
     */
    notify?: boolean;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    endTime?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    source?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateReservationRequest
     */
    conversionToken?: string;
}

/**
 * Check if a given object implements the UpdateReservationRequest interface.
 */
export function instanceOfUpdateReservationRequest(value: object): value is UpdateReservationRequest {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('surname' in value) || value['surname'] === undefined) return false;
    if (!('phoneNumber' in value) || value['phoneNumber'] === undefined) return false;
    if (!('email' in value) || value['email'] === undefined) return false;
    if (!('dateTime' in value) || value['dateTime'] === undefined) return false;
    if (!('diners' in value) || value['diners'] === undefined) return false;
    if (!('zone' in value) || value['zone'] === undefined) return false;
    if (!('policy' in value) || value['policy'] === undefined) return false;
    return true;
}

export function UpdateReservationRequestFromJSON(json: any): UpdateReservationRequest {
    return UpdateReservationRequestFromJSONTyped(json, false);
}

export function UpdateReservationRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateReservationRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'surname': json['surname'],
        'phoneNumber': json['phoneNumber'],
        'email': json['email'],
        'dateTime': json['dateTime'],
        'diners': json['diners'],
        'customerComments': json['customerComments'] == null ? undefined : json['customerComments'],
        'zone': json['zone'],
        'zoneId': json['zoneId'] == null ? undefined : json['zoneId'],
        'policy': UpdateReservationRequestPolicyFromJSON(json['policy']),
        'notify': json['notify'] == null ? undefined : json['notify'],
        'endTime': json['endTime'] == null ? undefined : json['endTime'],
        'source': json['source'] == null ? undefined : json['source'],
        'conversionToken': json['conversionToken'] == null ? undefined : json['conversionToken'],
    };
}

export function UpdateReservationRequestToJSON(json: any): UpdateReservationRequest {
    return UpdateReservationRequestToJSONTyped(json, false);
}

export function UpdateReservationRequestToJSONTyped(value?: UpdateReservationRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'surname': value['surname'],
        'phoneNumber': value['phoneNumber'],
        'email': value['email'],
        'dateTime': value['dateTime'],
        'diners': value['diners'],
        'customerComments': value['customerComments'],
        'zone': value['zone'],
        'zoneId': value['zoneId'],
        'policy': UpdateReservationRequestPolicyToJSON(value['policy']),
        'notify': value['notify'],
        'endTime': value['endTime'],
        'source': value['source'],
        'conversionToken': value['conversionToken'],
    };
}

